<div class="modal" [ngStyle]="{'background-color': backgroundColor}">
  <div class="content" [ngStyle]="{'width': contentWidth}">
    <div class="modal-header" *ngIf="heading" [ngStyle]="{'color': fontColor}">
      {{heading}}
    </div>
    <div class="modal-body" *ngIf="paragraph" [ngStyle]="{'color': fontColor}">
      {{paragraph}}
    </div>
  </div>
</div>